export const DATE_FIELD_FORMAT = "yyyy-MM-dd";
export const TIME_FIELD_FORMAT = "HH:mm:ss";
export const CONSENT_TO_ANALYTICS_NAME = "analytics-consent";
export const CONSENT_TO_FUNCTIONAL_COOKIES_NAME = "functional-cookies-consent";
export var CookieConsentEnum;
(function (CookieConsentEnum) {
    CookieConsentEnum["Accepted"] = "accepted";
    CookieConsentEnum["Rejected"] = "rejected";
    CookieConsentEnum["Undefined"] = "";
})(CookieConsentEnum || (CookieConsentEnum = {}));
export const EMPTY_VALUE_PLACEHOLDER = "--";
export const ROUNDING_CUTOFF = 1024 * 1024 * 10; // 10 MB
export const PRIORITY_TO_GRADE = {
    0: "F",
    1: "D",
    2: "C",
    3: "B",
    4: "A",
};
export const GRADE_TO_PRIORITY = {
    A: "P4",
    B: "P3",
    C: "P2",
    D: "P1",
    F: "P0",
};
//# sourceMappingURL=constants.js.map